export const APP_VERSION = "4.7.0";

export const statusOptions = [
  { value: "looped", label: "Looped" },
  { value: "clogged", label: "Clogged" },
  { value: "unused", label: "Unused" },
  { value: "disconnected", label: "Disconnected" },
  { value: "disabled", label: "Disabled" },
  { value: "stuck", label: "Stuck" },
];

export const DEFAULT_FILTERS = {
  issueId: '',
  center: '',
  organization: '',
  generalSearch: '',
  selectedStatuses: []
};